<template>
  <button v-if="shouldShowButton" class="trial-state-snackbar ri-label" :class="buttonVariant" @click="buttonClicked">
    <span v-if="inTrial"><span class="ri-bold-label">{{ daysLeftText }}</span> {{ trialCounterText }}</span>
    <span v-else class="ri-bold-label">המנוי לא פעיל</span>
    <icon v-if="!hideArrow" icon-name="arrow_back_ios_new" size="14px" weight="bold"/>
  </button>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { TRIAL_PERIODS } from '@/constants/subscription-state';
import trialUtils from '@/pages/responsive-pages/authenticated/trial/trial-utils';
import { mapGetters } from 'vuex';
import Segment from '@/Segment';

export default {
  name: 'TrialStateSnackbar',
  components: {
    Icon: BaseUI.Icon,
  },
  props: {
    closeModal: {
      type: Function,
      required: true,
    },
    hideArrow: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    ...mapGetters('subscriptionState', ['daysLeft', 'trialPeriod', 'inTrial', 'isFree', 'hasAccessToCashflow']),
    shouldShowButton() {
      if (this.isFree) {
        return false;
      }
      return this.inTrial || !this.hasAccessToCashflow;
    },
    buttonVariant() {
      if (this.inTrial) {
        return this.periodVariant;
      }
      return 'danger';
    },
    trialCounterText() {
      if (this.daysLeft === 1) {
        return 'נותר לתקופת הניסיון';
      }
      return this.daysLeftText ? 'נותרו לתקופת הניסיון' : 'תקופת הניסיון הסתיימה';
    },
    periodVariant() {
      switch (this.trialPeriod) {
      case TRIAL_PERIODS.BEGINNING: return 'default';
      case TRIAL_PERIODS.MIDDLE: return 'warning';
      case TRIAL_PERIODS.FINAL: return 'danger';
      default: return 'warning';
      }
    },
    daysLeftText() {
      return trialUtils.humanizeDays(this.daysLeft);
    },
  },
  methods: {
    buttonClicked() {
      Segment.trackUserInteraction('NavigationMenu_SubscriptionStatusClicked', { trialPeriod: this.trialPeriod });
      this.$router.push({
        name: 'AccountSettings',
        query: this.$route.query,
      });
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>

@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/spacings';
@import '~@riseupil/base-ui/src/scss/border-radius';

.trial-state-snackbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-radius: $ri-border-radius-medium;
  cursor: pointer;
  width: 100%;
  color: $riseup_beige;
  padding: $ri-spacing-xs $ri-spacing-sm $ri-spacing-xs $ri-spacing-xs;

  &.default {
    background: $riseup_green;
  }

  &.warning {
    background: $riseup_dark_yellow;
  }

  &.danger {
    background: $riseup_danger_red;
  }
}

</style>
